import React from 'react';
import useRUMView from 'common-datadog/useRUMView';
import {
  Box, Link, Paper, Typography,
} from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import LanguageIcon from '@mui/icons-material/Language';

import Screen from '../Screen';
import CreditBlockForm from '../CreditBlockForm';

import usePrequal from '../../resources/prequal/usePrequal';

import { CREDIT_BUREAUS, EQUIFAX_DETAILS, EXPERIAN_DETAILS } from '../../constants';
import { container, link } from './styles';

const FrozenFile = ({ failedUnfreeze = false }) => {
  useRUMView('frozen');
  const { data: prequal } = usePrequal();

  const header = failedUnfreeze
    ? 'Looks like your file is still frozen or in the process of being thawed.'
    : "You're unable to prequalify because your credit file is frozen.";

  const bureau = prequal.creditBureau === CREDIT_BUREAUS.EQUIFAX
    ? EQUIFAX_DETAILS
    : EXPERIAN_DETAILS;

  const subheader = failedUnfreeze
    ? `If you haven't already, contact ${bureau.name} to lift the freeze.`
    : `The quickest and easiest way to remove the credit freeze is to contact ${bureau.name} using one of the methods below:`;

  return (
    <Screen
      header={header}
      subheader={subheader}
    >
      <Paper variant="outlined" sx={container}>
        <Box
          component="img"
          src={bureau.logo}
          alt={bureau.name}
          width={125}
        />
        <Link variant="body2" underline="none" sx={link} href={`tel:${bureau.phone}`}>
          <CallIcon />
          {bureau.phone}
        </Link>
        <Link variant="body2" underline="none" sx={link} href={bureau.url}>
          <LanguageIcon />
          Manage My Freeze
        </Link>
      </Paper>
      <Typography variant="body2">
        Please note, credit agencies will lift a freeze in near real time, but
        it may take up to one hour to complete the request.
      </Typography>
      <CreditBlockForm status="frozen" />
    </Screen>
  );
};

export default FrozenFile;
